(() => {
  const normalize = (value) => {
    const text = String(value || '').toLowerCase();
    return typeof text.normalize === 'function'
      ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      : text;
  };

  const initDownloadCenter = (root) => {
    if (!root || root.dataset.fsDownloadReady === 'true') return;
    root.dataset.fsDownloadReady = 'true';

    const search = root.querySelector('[data-fs-search]');
    const cards = Array.from(root.querySelectorAll('[data-fs-card]'));
    const count = root.querySelector('[data-fs-count]');
    const clear = root.querySelector('[data-fs-clear]');
    const empty = root.querySelector('[data-fs-empty]');
    const filters = Array.from(root.querySelectorAll('[data-filter-group]'));
    const state = { category: 'all', resource: 'all', query: '' };

    const update = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryMatches = state.category === 'all' || card.dataset.category === state.category;
        const resourceTypes = (card.dataset.resourceTypes || '').split(/\s+/).filter(Boolean);
        const resourceMatches = state.resource === 'all' || resourceTypes.includes(state.resource);
        const searchMatches = !state.query || normalize(card.dataset.search).includes(state.query);
        const visible = categoryMatches && resourceMatches && searchMatches;

        card.classList.toggle('is-filtered-out', !visible);
        card.setAttribute('aria-hidden', String(!visible));
        if (visible) visibleCount += 1;
      });

      if (count) {
        const label = visibleCount === 1 ? root.dataset.resultSingular : root.dataset.resultPlural;
        count.textContent = `${visibleCount} ${label || ''}`.trim();
      }

      if (empty) empty.hidden = visibleCount !== 0;
      if (clear) clear.hidden = state.category === 'all' && state.resource === 'all' && !state.query;
    };

    const selectFilter = (group, value) => {
      if (!Object.prototype.hasOwnProperty.call(state, group)) return;
      state[group] = value;
      filters
        .filter((button) => button.dataset.filterGroup === group)
        .forEach((button) => {
          const active = button.dataset.filterValue === value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      update();
    };

    const reset = () => {
      state.category = 'all';
      state.resource = 'all';
      state.query = '';
      if (search) search.value = '';
      filters.forEach((button) => {
        const active = button.dataset.filterValue === 'all';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      update();
    };

    root.addEventListener('click', (event) => {
      const filter = event.target.closest('[data-filter-group]');
      if (filter && root.contains(filter)) {
        selectFilter(filter.dataset.filterGroup, filter.dataset.filterValue);
        return;
      }

      if (event.target.closest('[data-fs-clear], [data-fs-reset]')) reset();
    });

    if (search) {
      search.addEventListener('input', () => {
        state.query = normalize(search.value.trim());
        update();
      });
    }

    update();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-fs-download]')) initDownloadCenter(scope);
    scope.querySelectorAll?.('[data-fs-download]').forEach(initDownloadCenter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
